import { render, staticRenderFns } from "./InicioPrincipal.vue?vue&type=template&id=03ba18a0&"
import script from "./InicioPrincipal.vue?vue&type=script&lang=js&"
export * from "./InicioPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports